import { render, staticRenderFns } from "./CmgFooter.vue?vue&type=template&id=8569cc50&scoped=true&lang=pug"
import script from "./cmg-footer.ts?vue&type=script&lang=ts&external"
export * from "./cmg-footer.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFooter.vue?vue&type=style&index=0&id=8569cc50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8569cc50",
  null
  
)

export default component.exports